import React, { Component } from 'react';

import './Header.css';

class Header extends Component {
    render() {
        return (
            <div>
                <div className='text-center h2'>ULC Inspection Report</div>
            </div>
        );
    }
};

export default Header;



// WEBPACK FOOTER //
// ./src/components/Header.js